import React from 'react';
import { getKey } from '../../GenerateKey';
import {FormattedMessage} from 'react-intl';

export default function StatusColorIndicator() {
    const styles = {
        statusName: {
            'fontSize': '12px',
            'fontWeight': 'normal'
        }
    };

    const statusIndicators = [
        ['#367c2b', <FormattedMessage id={'labels.COMPLETED'} />],
        ['#ffb000', <FormattedMessage id={'labels.SENT_/_VIEWED'} />],
        ['#666666', <FormattedMessage id={'labels.CREATED'} />],
        ['#c21020', <FormattedMessage id={'labels.DECLINED'} />],
        ['#337dc1', <FormattedMessage id={'labels.UNDELIVERABLE'} />]
    ]

    return (
        <div style={{ 'marginRight': '2%' }}>
            {statusIndicators.map(indicator =>
                <p className="d-inline mr-2" key={'indicator-' + getKey()}>
                    <span className="font-weight-bold" style={{ 'fontSize': '60px', 'color': indicator[0] }}>.</span>
                    <span style={styles.statusName}>{indicator[1]}</span>
                </p>
            )
            }
        </div>
    )
}
